import { ReactNode, JSX } from 'react';

import { Outlet } from 'react-router-dom';

import CombinedDashboardProvider from '#client/hooks/CombinedDashboardProvider';
import { ApplicationStatusProvider } from '#client/hooks/useApplicationStatusContext';

import { AccountsDataProvider } from './AccountsDataContext';
import { BankingDataProvider } from './BankingDataContext';
import { InitialDataProvider } from './InitialDataContext';

import { OrderTaskProvider } from './hooks/useOrderTaskContext';
import { UnitAccountIdProvider } from './hooks/useUnitAccountId';

/**
 * DataProviders
 * Orchestrates the order of GraphQL data providers to ensure proper data dependencies. This ensures that each provider receives the data it needs from the previous context in the hierarchy.
 *
 * @param {ReactNode} children - Children to render
 * @returns {JSX.Element} - DataProviders context
 */
const DataProviders = ({ children }) => (
  <InitialDataProvider>
    <ApplicationStatusProvider>
      <AccountsDataProvider>
        <UnitAccountIdProvider>
          <OrderTaskProvider>
            <BankingDataProvider>{children}</BankingDataProvider>
          </OrderTaskProvider>
        </UnitAccountIdProvider>
      </AccountsDataProvider>
    </ApplicationStatusProvider>
  </InitialDataProvider>
);

const ContextLayout = () => (
  <DataProviders>
    <CombinedDashboardProvider>
      <Outlet />
    </CombinedDashboardProvider>
  </DataProviders>
);

export default ContextLayout;
